import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/profile";
import LeafDateTime from "../../../../common/leaf/LeafDateTime/LeafDateTime";
import "./RenewalDateInfo.scss";

type Props = {
  date: string;
  privacyFlag?: boolean;
  show?: boolean;
};

const RenewalDateInfo = (props: Props) => {
  const { date, privacyFlag, show } = props;
  const { t } = useTranslation(["profile"]);

  const renderInfo = date ? (
    <LeafDateTime date={date} options={{ month: "long", day: "numeric", year: "numeric" }} ignoreTimeZone={true} />
  ) : (
    `${t("aboProfile.datesTab.noRenewalDate", defaultContent["aboProfile"]["datesTab"]["noRenewalDate"])}`
  );

  const privacyView = privacyFlag === true ? "-" : renderInfo;

  if (show === true) {
    return (
      <div className="leaf-renewal-date">
        <div className="leaf-renewal-date__container">
          <div className="leaf-renewal-date__content-title">{`${t(
            "aboProfile.datesTab.renewalDate",
            defaultContent["aboProfile"]["datesTab"]["renewalDate"],
          )}`}</div>
          <div className="leaf-renewal-date__content-data">{privacyView}</div>
        </div>
      </div>
    );
  }

  return <></>;
};

export default RenewalDateInfo;
